import { FormControl, InputLabel, Select } from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import { WhiteDoubleArrow } from "../views/comparison_views/molecules/WhiteDoubleArrow";

export const AddModalSelectBox = ({
  options = [],
  value,
  onChange,
  label,
  id,
  labelId,
  name,
}) => (
  <FormControl className="slide-up-select-form-control" fullWidth>
    <InputLabel
      id={labelId}
      sx={{
        paddingTop: 10,
        width: "100%",
        transform: "none",
        textAlign: "center",
        color: "white",
        fontWeight: "bold",
        fontSize: 13,
        position: "absolute",
        top: -69,
        "&.Mui-focused": {
          color: "white",
        },
      }}
    >
      {label}
    </InputLabel>
    <Select
      className="slide-up-select"
      name={name}
      labelId={labelId}
      id={id}
      value={value}
      onChange={onChange}
      IconComponent={WhiteDoubleArrow}
      sx={{
        "& label.Mui-focused": {
          color: "white",
        },
        "& .MuiInput-underline:after": {
          borderBottomColor: "white",
        },
        "&.MuiOutlinedInput-root": {
          padding: "30px 20px 0px 20px",
          color: "white",
          margin: 0,
          "& fieldset": {
            border: "1px solid #FFFFFF11",
            borderRadius: 3.5,
          },
          "&:hover fieldset": {
            border: "1px solid #FFFFFF11",
            borderRadius: 3.5,
          },
          "&.Mui-focused fieldset": {
            border: "1px solid white",
            borderRadius: 3.5,
          },
        },
        "& .MuiInputBase-input": {
          paddingBottom: 1,
          marginBottom: 1.45,
          borderBottom: "1px solid #FFFFFF11",
          fontSize: "1rem",
          fontFamily: '"proxima-nova", "sans-serif"',
          backgroundColor: "rgba(255, 255, 255, 0.3)",
          paddingTop: 1,
          marginTop: 1.45,
          marginRight: "-24px",
        },
        "& .MuiOutlinedInput-root.Mui-focused": {
          "& .MuiInputBase-input": {
            borderBottom: "1px solid white",
          },
        },
      }}
    >
      {options.map((option) => (
        <MenuItem key={option.value} value={option.value}>
          {option.label}
        </MenuItem>
      ))}
    </Select>
  </FormControl>
);
